<template>
  <div class="relative">
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Join Us</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Community</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="absolute bg-design1 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd1.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design2 mob-hidden">
      <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
    </div>
    <div class="absolute bg-design3 mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="relative h-95per flex justify-end right-0">
      <img
        src="../../../assets/images/cp-bg.png"
        alt="cp bg"
        class="h-640px bg-white"
      />
    </div>
    <div
      class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
    >
      <!-- <img
        src="../../../assets/images/cp-bg.png"
        alt="cp bg"
        class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
      /> -->
      <div class="lg:w-1/2 md:w-1/2 w-full mt-5 md:hidden lg:hidden block">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-GAJUQlKJIw4hddw63eCxj-1733403764"
          class="md:hidden custborderradius lg:hidden block"
          alt="swiper-img"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <div class="">
          <p
            class="font-semibold fsize48 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
          >
            Community
          </p>

          <p
            class="lg:text-2xl md:text-2xl sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
          >
            Support Group is a safe place to interact with family caregivers and
            share your experience
            <!-- <a
              class="hover:text-white"
              target="_blank"
              href="https://tinyurl.com/Join-Our-CS-Community"
            > -->
            <span
              class="underline text-4f0a4b min-hidden font-semibold"
              @click="handleClick('register')"
              >Join Us</span
            >
            <!-- </a> -->
          </p>
          <div class="flex lg:pt-8 md:pt-8 mob-hidden">
            <!-- <a
              class="hover:text-white"
              target="_blank"
              href="https://tinyurl.com/Join-Our-CS-Community"
            > -->
            <base-button
              type="primary"
              class="px-5 btntext"
              @click="handleClick('register')"
              >Join Our Support Group</base-button
            >
            <!-- </a
            > -->
          </div>
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-GAJUQlKJIw4hddw63eCxj-1733403764
"
          class="custborderradius md:block lg:block hidden"
          alt="swiper-img"
        />
        <img
          src="../../../assets/images/caregiver/cg-mob-2.svg"
          class="w-full absolute md:hidden lg:hidden block"
          alt="swiper-img"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    handleClick(name) {
      // this.$router.push({ name: name });
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: name });
      } else {
        this.$swal.fire({
          title: "Registered",
          text: "You're already a registered member",
          icon: "info",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
  },
};
</script>
